
    var riot = require('riot')
    //src: starling/src/tags/map-status.html
riot.tag2('map-status',
  '<button onclick="{export}">save</button>',
  '',
  '', function(opts) {
"use strict";

var _this = this;

this.canvas = this.opts.canvas;
this.export = function () {
  console.log("NODES", JSON.stringify(_this.canvas.nodes));
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('map-status')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/map-status.html
// module id = 605
// module chunks = 0